/* eslint-disable react/prop-types */
import { Grid } from '@mui/material';
import SoftBox from 'components/SoftBox';
import SoftButton from "components/SoftButton";
import SoftTypography from 'components/SoftTypography';
import renderInputField from 'utils/renderInputField';

export default function Fields({ method, information, setInformation, handleUpdate, submit }) {
    const handleChange = (event) => {
        const { name, value } = event.target;
        setInformation({ ...information, [name]: value });
    };

    const handleImageChange = (event) => {
        const { name, files } = event.target;
        setInformation({ ...information, [name]: files });
    };

    return (
        <SoftBox py={3}>
            <SoftBox component="form" role="form">
                <Grid container spacing={3}>
                    {renderInputField("name", "نام شرکت", "text", "نام شرکت", information, handleChange)}
                    {renderInputField("description", "توضیحات", "text", "توضیحات", information, handleChange, 6)}
                    {renderInputField("phone", "موبایل", "text", "موبایل", information, handleChange)}
                    {renderInputField("address", "آدرس", "text", "آدرس", information, handleChange, 6)}
                    <Grid item xs={12} sm={6} xl={3}>
                        <SoftBox mb={1} ml={0.5}>
                            <SoftTypography component="label" variant="caption" fontWeight="bold">
                                لوگو
                            </SoftTypography>
                        </SoftBox>
                        <input
                            name="logo"
                            onChange={handleImageChange}
                            type="file"
                            style={{
                                background: 'white',
                                padding: '8px 12px',
                                width: '100%',
                                border: '0.0625rem solid #d2d6da',
                                borderRadius: '0.5rem',
                                color: '#495057'
                            }}
                            placeholder="Images"
                            accept=".jpg,.jpeg,.png"
                        />
                    </Grid>
                </Grid>
                <SoftButton
                    onClick={method !== "update" ? submit : handleUpdate}
                    style={{ marginTop: 40 }}
                    variant="gradient"
                    color="info"
                >
                    {method !== "update" ? "ثبت" : "آپدیت"}
                </SoftButton>
            </SoftBox>
        </SoftBox>
    );
}
